import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text } from "~/components/text";
import { StyledCalendar } from "~/components/styled-calendar";
import {
  getErrorMessage,
  parseDateRange,
  transformToInputDate,
  defaultRange,
} from "~/pages/books/components/filters/utils";
import { DateInput } from "./date-input";

export const SpecificDateFilter = ({ name }: { name: string }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation(["books"]);
  const range = useWatch({ name: `filters.${name}.range` }) || defaultRange;

  const error = getErrorMessage(range, t);

  const handleCalendarChange = (date: Date | undefined) => {
    if (!date) return;
    setValue(`filters.${name}.range`, {
      from: transformToInputDate(date),
      to: transformToInputDate(date),
    });
  };

  const handleInputChange = (rawValue: string) => {
    setValue(`filters.${name}.range`, { from: rawValue, to: rawValue });
  };

  return (
    <div className="p-2">
      <DateInput
        aria-label="specific date input"
        value={range?.from || ""}
        onChange={handleInputChange}
      />
      {error && (
        <Text variant="errorSmall" className="self-start">
          {error}
        </Text>
      )}
      <StyledCalendar
        onSelect={handleCalendarChange}
        selected={parseDateRange(range).from}
        mode="single"
      />
    </div>
  );
};
